import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import ChartWithTable from "./TicketCharts";
import { useNavigate } from "react-router-dom";
import {
    setZoneActions,
    setRegionActions,
    setGeoLoactionStateAction,
    settheNewDashboardRecordsActions,
    gettheAdvanceDashboardStateActions,
    gettheAdvanceDashboardRegionActions,
    gettheAdvanceDashboardZoneActions,
    settheFromDateForAdvanceDashboard,
    settheToateForAdvanceDashboard

} from "../../../Redux/Slice";
import Select from "react-select";
import { DateRangePicker, Stack } from "rsuite";
import subDays from "date-fns/subDays";
import startOfWeek from "date-fns/startOfWeek";
import endOfWeek from "date-fns/endOfWeek";
import addDays from "date-fns/addDays";
import "rsuite/dist/rsuite.css";
import isAfter from "date-fns/isAfter";
import useDebouncedEffect from 'use-debounced-effect';


const AdvanceDashboard = () => {
    const stateDisplay = useSelector(
        (state) => state.SideBarActive.SidebarActive
    );
    const state = useSelector((state) => state);
    const dispatch = useDispatch();
    const navigate = useNavigate();
    const RoleBased = useSelector((state) => state.SideBarFiles.Role);

    const [multiselect1, setMuliselect1] = useState([
        state.ClientBranchIDs.AdvanceDashboardRgion,
    ]);
    const [multiselect3, setMuliselect3] = useState([
        state.ClientBranchIDs.AdvanceDasboardZone,
    ]);
    const [datas, setData] = useState({
        zone: state.ClientBranchIDs.AdvanceDasboardZone?.value,
        state: state.ClientBranchIDs.AdvanceDashboardState?.value,
        region: state.ClientBranchIDs.AdvanceDashboardRgion?.value,
    });
    const [multiselect, setMuliselect] = useState([state.ClientBranchIDs.AdvanceDashboardState,
    ]);
    const initialStateSearch = {
        stateSearch: "",
        regionSearch: "",
        zoneSearch: "",
    };
    const [SearchedVal, setSearched] = useState(initialStateSearch);
    const initialDebouanceSearch = {
        stateSearch: "",
        regionSearch: "",
        zoneSearch: "",
    };

    const [SearchDebounance, setSearchDebounance] = useState(initialDebouanceSearch);


    ///--filter----------------
    let [nameList, setOptions] = useState([]);
    const [nameList2, setOptions2] = useState([]);
    const [nameList5, setOptions5] = useState([]);


    var today = new Date();
    var priorDate = new Date(new Date().setDate(today.getDate() - 30));
    var it = convert(today);
    var gt = convert(today);

    var st = convert(state.EmployeeVerificationsNeed.FROMDATE_AdvanceDashboard);
    var et = convert(state.EmployeeVerificationsNeed.TODATE_advanceDashboard);

    const [range, setrange] = useState(
        state.EmployeeVerificationsNeed.FROMDATE_AdvanceDashboard == ""
            ?
            []
            : [st, et]
    );

    const [datestae, setdatest] = useState(false);
    const [datefilter, setdatefilter] = useState({
        from_date: gt,
        to_date: it,
        range: true,
    });

    function convert(str) {
        var date = new Date(str),
            mnth = ("0" + (date.getMonth() + 1)).slice(-2),
            day = ("0" + date.getDate()).slice(-2);
        return [date.getFullYear(), mnth, day].join("-");
    }
    const predefinedBottomRanges = [
        {
            label: "Today",
            value: [new Date(), new Date()],
            placement: "left",
        },
        {
            label: "Yesterday",
            value: [addDays(new Date(), -1), addDays(new Date(), -1)],
            placement: "left",
        },
        {
            label: "This week",
            value: [startOfWeek(new Date()), endOfWeek(new Date())],
            placement: "left",
        },
        {
            label: "Last week",
            value: (value, index) => {
                const [start = new Date()] = value[index] || [];
                return [
                    addDays(startOfWeek(start, { weekStartsOn: 0 }), -7),
                    addDays(endOfWeek(start, { weekStartsOn: 0 }), -7),
                ];
            },
            placement: "left",
        },
        {
            label: "Last 30 days",
            value: [subDays(new Date(), 29), new Date()],
            placement: "left",
        },
    ];



    const capitalizeFirstLetter = (Letter) => {
        return Letter.charAt(0).toUpperCase() + Letter.slice(1);
    };
    useEffect(() => {
        if (range.length > 0 && !range.includes("NaN-aN-aN")) {
            const payload = {
                state: datas.state,
                region: datas.region,
                zone: datas.zone,
                filtername: datas.state == "" && datas.region == "" && datas.zone == "" ?
                    "all" : datas.state != "" && datas.region == "" && datas.zone == "" ? "state" :
                        datas.state != "" && datas.region != "" && "region",
                from_date: range[0],

                to_date: range[1],
                range: datefilter.range,
            }
            dispatch(settheNewDashboardRecordsActions(payload))
        }
    }, [datas, range])


    ///--------------State-----------------
    useEffect(() => {
        const payloads = {
            search: SearchedVal.stateSearch,
            page_size: "",
            page: 1,
        };
        dispatch(setGeoLoactionStateAction(payloads));
    }, [SearchedVal.stateSearch]);

    //--------------_Zone---------------
    useEffect(() => {
        const payloads = {
            search: SearchedVal.zoneSearch,
            page_size: 20,
            page: 1,
            counts: 1,
            region_id: datas.region,
        };
        dispatch(setZoneActions(payloads));
    }, [datas.region, SearchedVal.zoneSearch]);

    //-----Region---------
    useEffect(() => {
        const payloads = {
            search: SearchedVal.regionSearch,
            page_size: 20,
            page: 1,
            counts: 1, //-----only we ----get----the----selected regions , the--id only
            state: datas.state,
        };
        dispatch(setRegionActions(payloads));
    }, [datas.state, SearchedVal.regionSearch]);

    useEffect(() => {
        if (state.GeoState.State != undefined) {
            let objectArray = [];
            objectArray.push({ value: "", label: "ALL" });
            state.GeoState.State.forEach((element) => {
                objectArray.push({ value: element.id, label: element.state_name.toUpperCase() });
            });
            setOptions(objectArray);
        }
    }, [state.GeoState.State, SearchedVal.stateSearch]);
    ///  ///----------------------REgion-----------
    useEffect(() => {
        const Datas = [];

        if (state.regioncall.RegionDat != undefined) {
            let objectArray = [];
            objectArray.push({ value: "", label: "ALL" });
            state.regioncall.RegionDat.forEach((element) => {
                objectArray.push({ value: element.id, label: element.region_name.toUpperCase() });
            });

            setOptions2(objectArray);
        }
    }, [state.regioncall.RegionDat, SearchedVal.regionSearch]);

    ///-------------Zone--------------
    useEffect(() => {
        const Datas = [];

        if (state.ZonePart.Zone != undefined) {
            let objectArray = [];
            objectArray.push({ value: "", label: "ALL" });
            state.ZonePart.Zone.forEach((element) => {
                objectArray.push({ value: element.id, label: element.zone_name.toUpperCase() });
            });
            setOptions5(objectArray);
        }
    }, [state.ZonePart.Zone, SearchedVal.zoneSearch]);



    useDebouncedEffect(
        () => {
            if (setSearchDebounance) {
                setSearched({
                    ...SearchedVal,
                    stateSearch: SearchDebounance.stateSearch,
                    regionSearch: SearchDebounance.regionSearch,
                    zoneSearch: SearchDebounance.zoneSearch,
                });

            }
        },
        500,
        [SearchDebounance]
    );

    ///-----State----Input Changes
    const handleInputChange = (Val) => {
        setSearchDebounance({
            ...SearchDebounance,
            stateSearch: Val,

        });

    };

    ///---Region-----------------
    const handleInputRegion = (Val) => {
        setSearchDebounance({
            ...SearchDebounance,
            regionSearch: Val,
        });
    };
    ///----Zone---Name
    const handleInputZone = (Val) => {
        setSearchDebounance({
            ...SearchDebounance,
            zoneSearch: Val,
        });
    };

    //----Region----------------
    const handelRegionSlect = (selectedVal) => {
        if (selectedVal != null) {
            setMuliselect1(selectedVal);
            setMuliselect3({ value: "", label: "ALL" });
            dispatch(gettheAdvanceDashboardRegionActions(selectedVal));
            dispatch(gettheAdvanceDashboardZoneActions({ value: "", label: "ALL" }));

            setData({
                ...datas,
                region: selectedVal.value,
            });
        }
        if (selectedVal == null) {
            setData({
                ...datas,
                region: "",
                zone: "",
            });

            dispatch(gettheAdvanceDashboardRegionActions({ value: "", label: "ALL" }));
            dispatch(gettheAdvanceDashboardZoneActions({ value: "", label: "ALL" }));

            setMuliselect3({ value: "", label: "ALL" });
            setMuliselect1({ value: "", label: "ALL" });
        }
    };
    //----------------Zone
    const handleZone = (selectedVal) => {
        if (selectedVal != null) {
            setMuliselect3(selectedVal);
            setData({
                ...datas,
                zone: selectedVal.value,
            });

            dispatch(gettheAdvanceDashboardZoneActions(selectedVal));
        }
        if (selectedVal == null) {
            setData({
                ...datas,
                zone: "",
            });
            dispatch(gettheAdvanceDashboardZoneActions({ value: "", label: "ALL" }));

            setMuliselect3({ value: "", label: "ALL" });
        }
    };
    const handleSelectChange = (selectedVal) => {
        if (selectedVal != null) {
            setMuliselect(selectedVal);
            setMuliselect1({ value: "", label: "ALL" });
            setMuliselect3({ value: "", label: "ALL" });

            setData({
                ...datas,
                state: selectedVal.value,
                zone: "",
                region: "",
            });


            dispatch(gettheAdvanceDashboardStateActions(selectedVal));
            dispatch(gettheAdvanceDashboardRegionActions({ value: "", label: "ALL" }));

            dispatch(gettheAdvanceDashboardZoneActions({ value: "", label: "ALL" }));
        }
        if (selectedVal == null) {
            setMuliselect({ value: "", label: "ALL" });
            setMuliselect1({ value: "", label: "ALL" });
            setMuliselect3({ value: "", label: "ALL" });
            setData({
                ...datas,
                state: "",
                zone: "",
                region: "",
            });
            dispatch(gettheAdvanceDashboardStateActions({ value: "", label: "ALL" }));
            dispatch(gettheAdvanceDashboardRegionActions({ value: "", label: "ALL" }));
            dispatch(gettheAdvanceDashboardZoneActions({ value: "", label: "ALL" }));
        }
    };

    const handlechangedate = (value) => {
        if (value != null) {
            setrange((oldArray) => [...oldArray, value.slice(0, 10)]);
            setdatest(true);
            setdatefilter({
                ...datefilter,
                from_date: range[0],
                to_date: range[1],
                range: true,
            });
        }
    };

    const openMe = () => {
        const rsAnimFade = document.querySelector('.rs-anim-fade');
        if (rsAnimFade) {
            rsAnimFade.style.setProperty('left', '629.34px', 'important');
            rsAnimFade.style.setProperty('top', '186.109px', 'important');
        }
    }

    const CloseDateRange = () => {
        const rsAnimFade = document.querySelector('.rs-anim-fade');
        if (rsAnimFade) {
            rsAnimFade.style.setProperty('display', 'none', 'important');
        }
    }
    useEffect(() => {
        if (range.length > 0 && !range.includes("NaN-aN-aN")) {
            dispatch(settheFromDateForAdvanceDashboard(range[0]));
            dispatch(settheToateForAdvanceDashboard(range[1]));
        }
    }, [range])

    return (
        <>
            <div className={stateDisplay ? "outterContent" : "inner-Content"}>
                <div
                    className="Header-Details ClientBranch row"
                    style={{ padding: "14px 28px" }}
                >
                    <div
                        class="col-sm-7 auto"
                        style={{
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "flex-start",
                            justifyContent: "flex-start",
                        }}
                    >
                        {RoleBased != undefined ? (
                            <h2 class="user-name mb-0 WelcomeContent">{`Welcome ${capitalizeFirstLetter(
                                RoleBased
                            )}! `}</h2>
                        ) : null}

                    </div>


                </div>

                <div
                    className=" row Filters "
                    style={{
                        marginRight: "0px",
                        marginLeft: "0px",
                        padding: "0px 30px",
                        zIndex: "89",
                        marginTop: "14px "
                    }}
                >
                    <div
                        className="col-sm-2"
                        style={{ marginTop: "-19px", zIndex: "99" }}
                    >
                        <label
                            for="validationCustom01"
                            class="form-label"
                            style={{ fontSize: "19px" }}
                        >
                            State
                        </label>
                        <Select
                            className="Selects"
                            styles={{ position: "relative", top: "60px" }}
                            onSelect={(e) => {
                                setMuliselect(e);
                            }}
                            onChange={(e) => {
                                handleSelectChange(e);
                            }}
                            options={nameList}
                            onInputChange={handleInputChange}
                            onremoved={(e) => {
                                setMuliselect({ value: "", label: "All" });
                                console.log(e, "jjk9090");
                            }}
                            value={multiselect}
                            labelledBy="Select"
                        />
                    </div>

                    <div className="col-sm-2" style={{ marginTop: "-19px" }}>
                        <label
                            for="validationCustom01"
                            class="form-label"
                            style={{ fontSize: "19px" }}
                        >
                            Region
                        </label>
                        <Select
                            className="Selects"
                            styles={{ position: "relative", top: "60px" }}
                            onSelect={(e) => setMuliselect1(e)}
                            onChange={(e) => {
                                handelRegionSlect(e);
                            }}
                            options={nameList2}
                            labelledBy="Select"
                            isClearable={true}
                            onremoved={(e) => {
                                setMuliselect1(e);
                            }}
                            value={multiselect1}
                            onInputChange={handleInputRegion}

                        />
                    </div>

                    <div className="col-sm-2" style={{ marginTop: "-19px" }}>
                        <label
                            for="validationCustom01"
                            class="form-label"
                            style={{ fontSize: "19px" }}
                        >
                            Zone
                        </label>
                        <Select
                            className="Selects"
                            styles={{ position: "relative", top: "60px" }}
                            onSelect={(e) => setMuliselect3(e)}
                            onChange={(e) => {
                                handleZone(e);
                            }}
                            value={multiselect3}
                            options={nameList5}
                            isClearable={true}
                            onremoved={(e) => {
                                setMuliselect3(e);
                                console.log(e, "jjk9090");
                            }}
                            labelledBy="Select"
                            onInputChange={handleInputZone}
                        />
                    </div>


                    <div
                        className="col-sm-2 SelectedDate"
                        style={{ marginTop: "-21px" }}
                    >


                        <label
                            for="validationCustom01"
                            class="form-label"
                            style={{ fontSize: "19px", width: "100%" }}
                        >
                            Select Date
                            <span style={{ color: "red" }}>*</span>

                        </label>

                        <div className="datepicker_dash">
                            <DateRangePicker
                                onOpen={() => {
                                    openMe()
                                }}
                                onClose={() => {
                                    CloseDateRange()
                                }}
                                defaultValue={
                                    state.EmployeeVerificationsNeed.FROMDATE_AdvanceDashboard == ""
                                        ? [
                                        ]
                                        : [
                                            new Date(state.EmployeeVerificationsNeed.FROMDATE_AdvanceDashboard),
                                            new Date(state.EmployeeVerificationsNeed.TODATE_advanceDashboard),
                                        ]
                                }
                                disabledDate={(date) => isAfter(date, new Date())}
                                editable={false}
                                appearance="default"
                                placement="bottomEnd"
                                size="lg"
                                ranges={predefinedBottomRanges}
                                placeholder="From - To"
                                onClean={false}
                                onChange={(e) => {
                                    if (e != null) {
                                        setrange([]);
                                        e.forEach((newValue) => {
                                            var tzoffset = new Date().getTimezoneOffset() * 60000; //offset in milliseconds
                                            var localISOTime = new Date(newValue - tzoffset)
                                                .toISOString()
                                                .slice(0, -1);
                                            handlechangedate(localISOTime);
                                        });
                                    }
                                }}
                            />
                        </div>
                    </div>




                </div>
                <br />

                <ChartWithTable />
            </div>


        </>
    )
}

export default AdvanceDashboard


